import { useTranslation } from "react-i18next";

import type { Tree } from "../data/types";

/**
 * District and village in one place, both translated. The raw `location.village`
 * is the fallback: it is the authored English name, which beats rendering nothing.
 */
export function PlaceLabel({
  tree,
  content,
}: {
  tree: Tree;
  content: (key: string | null | undefined) => string;
}) {
  const { t } = useTranslation();
  const district = t(`district.${tree.location.district}`);
  const village = content(tree.keys.village) || tree.location.village || "";

  return <>{village ? `${district} · ${village}` : district}</>;
}
